module.exports = __webpack_public_path__ + "img/search.a0089277.svg";